import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import SolutionsPage from "./pages/SolutionsPage";
import ProjectsPage from "./pages/ProjectsPage";
import MonitoringPage from "./pages/MonitoringPage";
import ContactPage from "./pages/ContactPage";
import WaterAtmPage from "./pages/WaterAtmPage";
import PumpsPage from "./pages/PumpsPage";
import WaterTreatmentPage from "./pages/WaterTreatmentPage";
import OnlineMonitoringPage from "./pages/OnlineMonitoringPage";
import WastewaterPage from "./pages/WastewaterPage";
import ChlorinationPage from "./pages/ChlorinationPage";
import ClientsPage from "./pages/ClientsPage";
import News from "./pages/News";
import ScrollToTop from "./components/ScrollToTop";


export default function App() {
  
  return (
    <HelmetProvider>
    <Router>
       <ScrollToTop />
      <div className="min-h-screen bg-slate-50 text-slate-900">
        <Navbar />
        
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/clients" element={<ClientsPage />} />
          <Route path="/news" element={<News />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/monitoring" element={<MonitoringPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/solutions/water-atm" element={<WaterAtmPage />} />
          <Route path="/solutions/pumps" element={<PumpsPage />} />
          <Route path="/solutions/water-treatment" element={<WaterTreatmentPage />} />
          <Route path="/solutions/online-monitoring" element={<OnlineMonitoringPage />} />
          <Route path="/solutions/wastewater" element={<WastewaterPage />} />
          <Route path="/solutions/chlorination" element={<ChlorinationPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
    </HelmetProvider>
  );
}